<div class="remove-exam-container">
    <div class="grid-container">
        <ag-grid-angular #datagrid class="worklist-grid ag-theme-material" [gridOptions]="gridOptions" [rowData]="items" (selectionChanged)="onSelectionChange($event)">
        </ag-grid-angular>
    </div>

    <div class="remove-exam-message">
        <label>{{message}}</label>
    </div>

    <div class="remove-exam-buttons">
        <button mat-button [class.remove-exam-part-disabled]="!canRemove()" (click)="onRemove()">
            <p translate>RemoveExam</p>
        </button>
        <button mat-button (click)="onClose(false)">
            <p translate>Cancel</p>
        </button>
    </div>

</div>
